import { graphql } from 'react-relay';

export const unifiedIngestListTransformTemplates = graphql`
  query unifiedIngestListTemplatesQuery(
    $params: unified_ingest_transform_templates_list_params!
  ) {
    unified_ingest_transform_templates_list(params: $params) {
      owner_name
      templates_list {
        user_id
        org_slug
        template_id
        template_display_name
        template_uuid
        source_system
        target_table
        is_production
      }
    }
  }
`.default;
